var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { convertUnix, minsToSecs, secToMins } from 'helpers/timeUtilities';
import { setT } from 'helpers/translationUtilities';
import { WEBSOCKET_MESSAGE } from 'components/constants';
import { stageUpdateRequest } from '../../../../../socketConnection/socketMessageRequests/stageRequests';
CollapseTableContent.propTypes = {
    stageDescription: PropTypes.any,
    times: PropTypes.object.isRequired,
    inputMode: PropTypes.bool,
    stageId: PropTypes.string,
    hasStageEnded: PropTypes.bool.isRequired
};
export default function CollapseTableContent(_a) {
    var _b;
    var _c = _a.stageDescription, stageDescription = _c === void 0 ? '' : _c, times = _a.times, stageId = _a.stageId, hasStageEnded = _a.hasStageEnded;
    var dispatch = useDispatch();
    var _d = useState(times.formatted.plannedMins), plannedTime = _d[0], setTimePlanned = _d[1];
    var _e = useState(false), inputMode = _e[0], setInputMode = _e[1];
    function onStageUpdateRequest(stageId, params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = dispatch;
                        _b = { type: WEBSOCKET_MESSAGE };
                        return [4 /*yield*/, stageUpdateRequest(stageId, params)];
                    case 1:
                        _a.apply(void 0, [(_b.payload = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    }
    function onTimeChangeSubmit(e) {
        e.preventDefault();
        onStageUpdateRequest(stageId, { duration: minsToSecs(plannedTime) });
        setInputMode(false);
    }
    return (React.createElement("div", { className: "collapse-custom-content" },
        React.createElement("div", { className: "d-block d-flex-md flex-wrap flex-justify-content-between flex-direction-row-reverse-md" },
            React.createElement("div", { className: "flex-shrink-1" },
                React.createElement("form", { className: "d-flex flex-align-items-center flex-wrap flex-nowrap-md mar-bottom-15 mar-bottom-0-md", onSubmit: function (e) { return onTimeChangeSubmit(e); } },
                    React.createElement("div", { className: "collapse-custom-content__times" },
                        React.createElement("div", { className: "flex-align-self-center" },
                            setT('planned_time'),
                            ":"),
                        React.createElement("div", null,
                            !inputMode ?
                                secToMins(times.planned) :
                                React.createElement("input", { style: { display: "inline-block", width: '65px', padding: '10px' }, className: "main-input main-input--auto-height text-align-center bold", name: "planned_time", value: plannedTime, onChange: function (e) { return setTimePlanned(Number(e.target.value)); } }),
                            " ",
                            setT('minutes_short')),
                        React.createElement("div", null,
                            setT('spent_time'),
                            ":"),
                        React.createElement("div", null,
                            secToMins((_b = times.spent) !== null && _b !== void 0 ? _b : 0),
                            " ",
                            setT('minutes_short')),
                        React.createElement("div", null,
                            setT('estimated_end'),
                            ":"),
                        React.createElement("div", null, convertUnix(times.estimated_end))),
                    !hasStageEnded ? setButton(inputMode, setInputMode) : null)),
            React.createElement("div", { className: "flex-grow-1 mar-bottom-10 mar-bottom-0-md" },
                React.createElement("div", { className: "custom-content-area", dangerouslySetInnerHTML: { __html: stageDescription } })))));
}
function setButton(inputMode, setInputMode) {
    if (inputMode) {
        return (React.createElement("button", { type: "submit", className: "main-button main-button--lg" }, setT('save')));
    }
    return (React.createElement("button", { type: "button", className: "main-button main-button--lg", onClick: function (e) { return onOpenButtonClick(e, setInputMode); } }, setT('change')));
}
function onOpenButtonClick(event, setInputMode) {
    event.preventDefault();
    setInputMode(true);
}
